import { AddHospitalRequestPayload } from "@/data/payload/admin/add-hospital-request-payload";
import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AddHospitalUsecase {
  constructor(private readonly hospitalManageRepository: HospitalRepository) {}

  async execute(hospitalInfo: HospitalInfoEntity): Promise<SATResult<void, SATError>> {
    const payload: AddHospitalRequestPayload = {
      hospitalName: hospitalInfo.name,
      hospitalCode: hospitalInfo.code,
    };
    const result = await this.hospitalManageRepository.addHospitalInfo(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
